// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"79537b54","192":"f08075fd","767":"e823892d"}[chunkId] + ".chunk.css";
};